import { connect } from 'react-redux'
import { addWordToIgnoreList } from '../../actions/editor'
import CapsSpan from './CapsSpan'

const mapStateToProps = (state) => {
    return {
        user: state.user,
    }
}

const mapDispatchToProps = dispatch => ({
    addWordToIgnoreList: word => {
        dispatch(addWordToIgnoreList(word))
    },
})

const CapsSpanContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(CapsSpan)

export default CapsSpanContainer
